<template>
  <div>
    <el-row style="background-color: #0a84ff" align="middle">
      <el-col :span="8">
<!--        <el-image src="logo/logo.png" style="width: 70px;margin: 3px; border: solid 1px #4e4e4e;"/>-->
      </el-col>
      <el-col :span="8" style="text-align: center;">
        <text style="font-size: 30px;color:#FFFFFF;">模具加工进度管理系统</text>
      </el-col>
      <el-col :span="8" style="font-size: 20px;color:#FFFFFF;text-align: end;">
        {{ currentDateTime }}
        <el-icon class="switchButton" @click="allMin">
          <SwitchButton/>
        </el-icon>
      </el-col>
    </el-row>
    <div style="margin: 50px 0">
      <div v-if="equipmentList.length === 0" style="text-align: center">
        <text style="font-size: 50px;">{{ '此终端下无设备' }}</text>
      </div>
      <el-row v-if="equipmentList.length !== 0">
        <el-col :span="22" style="overflow: auto">
          <el-row justify="center" align="middle" style="margin-left: 150px">
            <div v-for="equipment in equipmentList" :key="equipment.id">
              <div class="equipmentBox"
                   :style="{backgroundColor: equipment.background_color}"
                   @click="openBeginWork(equipment, $event)">

                <el-col style="">{{ equipment.equipment_name }}</el-col>
<!--                <el-col>{{ equipment.id }}</el-col>-->
              </div>
            </div>
          </el-row>
        </el-col>

        <el-col :span="2">
          <div style="text-align: center;width: 100px;font-size: 20px;">
            <text style="text-align: center">图例</text>
            <div v-for="status in statusList" :key="status.name">
              <div
                  :style="{marginTop: '10px',borderRadius: '5px',color: 'white',backgroundColor: status.background_color}">
                {{ status.name }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div :style="{overflow: 'auto',}"  v-if="tabQuery">
      <el-tabs type="border-card">
        <el-tab-pane label="加工中">
          <FrameQuery ref="refreshInProcessQuery" componentParam="mes_mold_processing_in_process" :parentData="this.processData"
                      style="width: 100%;"/>
        </el-tab-pane>
        <el-tab-pane label="已完成">
          <FrameQuery ref="refreshFinishQuery" componentParam="mes_mold_processing_finish" :parentData="this.processData"
                      style="width: 100%;"/>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>

  <!--开始工作页面-->
  <el-dialog v-model="beginWork" width="900px" :close-on-click-modal="false" :show-close="false" draggable style="padding: 0">
    <!--title-->
    <template #header="{close}">
      <el-row justify="space-between" style="background-color: #07CB14;font-size: 30px">
        <el-col :span="8"></el-col>
        <el-col :span="8" style="text-align: center;color: white;">开始加工</el-col>
        <el-col :span="8" style="text-align: end;padding-right: 10px;color: #07CB14;">
          <el-button @click="close">
            <el-icon>
              <Close/>
            </el-icon>
          </el-button>
        </el-col>
      </el-row>
    </template>
    <!--内容-->
    <div style="margin: 10px">
      <div>{{ '1、选择加工的设备:' }}</div>
      <el-row justify="center" style="margin-bottom: 20px">
        <div class="equipmentBox" style="background-color: #07CB14;">
          <el-col style="">{{ equipment.equipment_name }}</el-col>
<!--          <el-col>{{ equipment.id }}</el-col>-->
        </div>
      </el-row>
      <div>{{ '2、扫描零件二维码:' }}</div>
      <el-row justify="center" style="margin-bottom: 20px">
        <el-input v-model="process.part_qr_code" placeholder="请扫描零件二维码" clearable ref="partQrCodeInput"
                  @keyup.enter="getPartDetailsByCode(process.part_qr_code)"
                  @clear="getPartDetailsByCode(process.part_qr_code)"
                  style="width: 40%;height: 40px;margin-bottom: 10px"/>
        <FrameQuery ref="refreshQuery" componentParam="mes_mold_processing_scheduling_part" :parentData="this.processDetails"
                    style="width: 100%;"/>
      </el-row>
      <div>{{ '3、选择加工工序:' }}</div>
      <el-row justify="space-evenly" style="margin-bottom: 10px">
        <div v-for="process in processList" :key="process.id">
          <div class="processBox" :class="selectedProcessId === process.id?'box-next':''"
               @click="selectProcess(process)">
            <el-col>{{ process.name }}</el-col>
            <el-col>预估时间：{{ process.estimated_duration }}分钟</el-col>
            <el-col v-if="process.process_cnt !== 0">历史加工：{{ process.process_cnt }}次</el-col>
          </div>
        </div>
      </el-row>
      <el-row justify="center">
        <el-button class="processBox" :class="'box-next'" style="margin-bottom: 20px" @click="confirmStart()">确认开始
        </el-button>
      </el-row>
    </div>

  </el-dialog>

  <!--结束工作页面-->
  <el-dialog v-model="finishWork" width="950px" :close-on-click-modal="false" :show-close="false" draggable style="padding: 0">
    <template #header="{close}">
      <el-row justify="space-between" style="background-color: #FF8600;font-size: 30px">
        <el-col :span="8"></el-col>
        <el-col :span="8" style="text-align: center;color: white;">结束加工</el-col>
        <el-col :span="8" style="text-align: end;padding-right: 10px;color: #07CB14;">
          <el-button @click="close">
            <el-icon>
              <Close/>
            </el-icon>
          </el-button>
        </el-col>
      </el-row>
    </template>
    <div style="margin: 10px ">
      <div>{{ '1、选择加工的设备和工序:' }}</div>
      <el-row justify="space-evenly"
              style="margin-bottom: 20px;align-items: center;color: white;font-size: 25px;text-align: center;">
        <div style="width: 150px;height: 80px;background-color: #FF8600;border-radius: 5px;padding: 0.7em">
          <el-col style="">{{ equipment.equipment_name }}</el-col>
<!--          <el-col>{{ equipment.id }}</el-col>-->
        </div>
        <div v-if="equipmentProcessDetail !== null">
          <div style="width: 150px;height: 50px;background-color: #FF8600;border-radius: 5px;align-content: center">
            <el-col style="">{{ equipmentProcessDetail.working_procedure_name }}</el-col>
          </div>
        </div>

      </el-row>
      <div>{{ '2、当前加工的零件:' }}</div>
      <el-row justify="center" style="margin-bottom: 20px">
        <div style="font-size: 30px;">{{ equipmentProcessDetail.part_qr_code }}</div>
        <FrameQuery ref="refreshQuery" componentParam="mes_mold_processing_scheduling_part" :parentData="this.processDetails"
                    style="width: 100%;"/>
      </el-row>
      <div>{{ '3、加工信息:' }}</div>
      <el-row style="margin-bottom: 10px">
        <FrameQuery ref="refreshDetailQuery" componentParam="mes_mold_process_detail"
                    :parentData="this.processLogDetails" style="width: 100%;"/>
      </el-row>
      <div>{{ '4、扫描该零件的二维码，自动结束加工:' }}</div>
      <el-row justify="center">
        <el-input v-model="equipmentProcessDetail.part_qr_code_new" placeholder="请扫描零件二维码" clearable
                  ref="partQrCodeNewInput"
                  @keyup.enter="finishWorkProcess(equipmentProcessDetail.part_qr_code_new)"
                  style="width: 40%;height: 40px;margin-bottom: 50px"/>
      </el-row>
    </div>

  </el-dialog>

</template>

<script>
import {Close, SwitchButton} from "@element-plus/icons-vue";

export default {
  name: "AutomaticTerminal",
  computed: {},
  components: {Close, SwitchButton},
  provide() {
    return {
      $fn: {
        openLink: () => {
          this.openLinkWindow();
        }
      }
    }
  },
  data() {
    return {
      currentUrl:'',
      currentDateTime: this.formatDateTime(new Date()),
      equipmentList: [],
      statusList: [],
      beginWork: false,
      finishWork: false,
      equipment: {},
      processDetails: {},
      processData: {},
      processList: [],
      selectedProcessId: '',
      process: {},
      equipmentProcessDetail: {},
      processLogDetails: {},
      scanCode: '',

      lastInputTime: 0,
      isScanning: false,
      tabQuery: false
    };
  },
  async created() {
    await this.loadConfig()

    let user = await this.$http('sysUserService.getCurrentUser');
    this.$store.commit('core/CURRENT_USER_INIT', user)

    await this.loadDefinition()

    let data = await this.$http('sysDictService.selectAll')
    this.$store.commit('core/INIT_DICT', data)

    document.title = '模具加工进度管理系统';

    // 每秒钟更新一次当前日期时间
    setInterval(() => {
      this.currentDateTime = this.formatDateTime(new Date());
    }, 1000);

    await this.getEquipmentStatus();
    await this.getEquipmentByTerminal();

  },
  mounted() {

  },
  beforeUnmount() {
    this.beforeDestroy()
  },
  methods: {

    getCurrentUrl1(){
      let url = window.location.origin + window.location.hash;
      this.currentUrl = url ;
    },

    async loadDefinition() {
      let data = await this.$http('frameUiService.loadDefinition')
      this.$store.dispatch('core/initDefinition', data);
      this.getCurrentUrl1()
      this.processData.address = this.currentUrl
      this.tabQuery = true;
    },

    async loadConfig() {
      let data = await this.$http('sysConfigService.getWebConfig')
      this.$store.commit('core/INIT_SYS_CONFIG', data)
      this.$store.commit('wallpaper/INIT_CONFIG', data)
      document.title = this.$store.getters['core/getAppName']
    },

    // 格式化当前日期时间
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      return `${year}-${month}-${day} ${weekdays[date.getDay()]} ${hours}:${minutes}:${seconds}`;
    },

    //返回桌面
    allMin() {
      window.close()
    },

    //获取设备状态
    async getEquipmentStatus() {
      this.statusList = await this.$http('mesMoldEquipmentService.getEquipmentStatus')
    },

    //获取设备
    async getEquipmentByTerminal() {
      let address = this.$route.params.address
      let params = {address: address}
      this.equipmentList = await this.$http('mesMoldEquipmentService.getEquipmentByTerminal', params)
    },

    //打开工作界面
    openBeginWork(equipment) {
      // 在组件挂载后执行的生命周期钩子函数
      this.addKeyboardListener();
      this.equipment = equipment
      if (equipment.status === 'free') {
        this.beginWork = !this.beginWork;
        if (this.beginWork === true){
          this.process.part_qr_code = ''
          this.getPartDetailsByCode(this.process.part_qr_code)
        }
      } else if (equipment.status === 'in_use') {
        this.finishWork = !this.finishWork;
        if (this.finishWork === true) {
          //获取设备工作数据
          this.getFinishWorkProcess(equipment)
        }
      }
    },

    //扫描枪扫描
    addKeyboardListener() {
      document.addEventListener('keydown', this.handleKeyDown);
    },
    handleKeyDown(event) {
      const currentTime = Date.now();
      const timeDiff = currentTime - this.lastInputTime;

      // 如果时间差小于100毫秒，认为是扫码枪输入
      if (timeDiff < 40) {
        this.isScanning = true;
      } else {
        this.isScanning = false;
      }
      this.lastInputTime = currentTime;

      if (event.key.length === 1 && this.isScanning) {
        this.scanCode += event.key
      }

      //只要是手动输入的就把scanCode清空
      if (!this.isScanning){
        this.scanCode = ''
      }

      if ('Enter' === event.key  && this.isScanning) {
        if (this.beginWork) {
          this.process.part_qr_code = this.scanCode
          this.$refs.partQrCodeInput.focus();
        } else if (this.finishWork) {
          this.equipmentProcessDetail.part_qr_code_new = this.scanCode
          this.$refs.partQrCodeNewInput.focus();
        }
        this.scanCode = ''
      }
    },
    removeKeyboardListener() {
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
      // 在组件销毁前执行的生命周期钩子函数
      this.removeKeyboardListener();
    },

    //获取排程和该设备关联工序
    async getProcessListByScheduling() {
      let params = {}
      params.equipment_id = this.equipment.id
      params.part_qr_code = this.process.part_qr_code
      this.processList = await this.$http('mesMoldEquipmentService.getProcessListByScheduling', params)
    },

    //选择工序
    selectProcess(process) {
      if (this.selectedProcessId === process.id) {
        this.selectedProcessId = ''
        this.process.working_procedure = ''
        return
      }
      this.selectedProcessId = process.id
      this.process.working_procedure = process.working_procedure
    },

    //根据零件二维码获取模具，零件信息
    async getPartDetailsByCode(part_qr_code) {
      if (!part_qr_code) {
        this.processDetails = {model_id: 'mes_mold_processing_scheduling_details',}
        this.processDetails.part_qr_code = 1
        this.$refs.refreshQuery?.search();
        this.processList = []
        return
      }
      if (this.beginWork) {
        await this.$http('mesMoldEquipmentService.getWorkProcessIn', {part_qr_code: part_qr_code})
        // console.log("isInProcess-=",isInProcess)
        // if (isInProcess) {
        //   return this.$message.error('该零件已在加工中')
        // }
        await this.getProcessListByScheduling()
      }
      this.processDetails = {model_id: 'mes_mold_processing_scheduling_details',}
      this.processDetails.part_qr_code = part_qr_code
      await this.$refs.refreshQuery?.search();
    },

    //确认开始工作
    async confirmStart() {

      this.process.equipment_id = this.equipment.id
      this.process.address = this.currentUrl

      if (!this.process.part_qr_code) {
        return this.$message.error('请扫描零件二维码')
      }
      if (!this.process.working_procedure) {
        return this.$message.error('请选择工序')
      }
      await this.$http('mesMoldEquipmentService.confirmStart', this.process)

      this.$message.success('开始加工')
      await this.getEquipmentByTerminal();
      this.selectedProcessId = '';
      this.process = {};
      this.processList = []
      this.processDetails = {model_id: 'mes_mold_processing_scheduling_details',}
      this.processDetails.part_qr_code = 1
      await this.$refs.refreshQuery?.search();
      await this.$refs.refreshFinishQuery?.search();
      await this.$refs.refreshInProcessQuery?.search();
      this.beginWork = false;
    },

    //获取设备工作数据
    async getFinishWorkProcess(equipment) {
      let params = {}
      params.equipment_id = equipment.id
      params.equipment_status = 'in_use'
      this.equipmentProcessDetail = await this.$http('mesMoldEquipmentService.getFinishWorkProcess', params)
      //获取零件信息
      await this.getPartDetailsByCode(this.equipmentProcessDetail.part_qr_code)

      //获取加工信息
      this.processLogDetails = {model_id: 'mes_mold_processing_scheduling_log',}
      if (!this.equipmentProcessDetail.part_qr_code || !this.equipmentProcessDetail.equipment_id) {
        this.processLogDetails.part_qr_code = 1
        this.processLogDetails.equipment_id = 2
        this.processLogDetails.equipment_id = 3
      } else {
        this.processLogDetails.part_qr_code = this.equipmentProcessDetail.part_qr_code
        this.processLogDetails.equipment_id = this.equipmentProcessDetail.equipment_id
        this.processLogDetails.working_procedure = this.equipmentProcessDetail.working_procedure
      }
      await this.$refs.refreshDetailQuery?.search();

    },

    //扫码结束加工
    async finishWorkProcess(part_qr_code_new) {

      if (part_qr_code_new !== this.equipmentProcessDetail.part_qr_code) {
        return this.$message.error('扫描的零件二维码与加工中的零件不符')
      }

      await this.$http('mesMoldEquipmentService.finishWorkProcess', this.equipmentProcessDetail)
      this.$message.success('结束加工')
      this.finishWork = false;
      this.equipmentProcessDetail = {}
      this.processLogDetails = {}
      await this.getEquipmentByTerminal();
      await this.$refs.refreshInProcessQuery?.search();
      await this.$refs.refreshFinishQuery?.search();
    }


  },
}
</script>

<style lang="less" scoped>

.switchButton {
  margin: 0 40px 0 40px;
}

.switchButton:hover {
  cursor: pointer;
}

:deep(.el-dialog__header) {
  border: none;
}

//设备样式
.equipmentBox {
  width: 150px;
  height: 80px;
  border-radius: 5px;
  margin: 5px;
  text-align: center;
  font-size: 25px;
  color: white;
  padding: 0;
  align-content: center;
}

//工序样式
.processBox {
  width: 150px;
  height: 80px;
  color: #07CB14;
  text-align: center;
  align-content: center;
  border-radius: 5px;
  border: 1px solid #07CB14;
}

.box-primary {
  background-color: white;
  color: #07CB14;
}

.box-next {
  background-color: #07CB14;
  color: white;
}

</style>